import * as React from 'react';
import {FormattedMessage} from '@meiko/react-intl';
import Panel from './Panel';
import PanelRow from './PanelRow';

export default function LeadAdditionalInfoPanel({products, url, organization, lead}) {
	if (!lead) {
		return null;
	}

	const meta = lead.meta
		? Object.entries(lead.meta).map(([key, value]) => ({
				key,
				value,
		  }))
		: [];

	return (
		<Panel title={<FormattedMessage id="Details" />}>
			<div className="overflow-x-auto flex flex-col">
				<PanelRow
					label={<FormattedMessage id="Organization" />}
					value={organization?.title ?? '-'}
				/>
				<PanelRow
					label={<FormattedMessage id="Products" />}
					value={products?.map(p => p.title).join(', ') ?? '-'}
				/>
				<PanelRow label={<FormattedMessage id="Domain" />} value={url ?? '-'} />
				<PanelRow label={<FormattedMessage id="Source" />} value={lead.source ?? '-'} />
				<PanelRow
					label={<FormattedMessage id="Details for handler" />}
					value={lead.handlerComment ?? '-'}
				/>
				<PanelRow
					label={<FormattedMessage id="Details for visit" />}
					value={lead.comment ?? '-'}
				/>

				{meta.length > 0 && (
					<>
						<div className="text-xs font-semibold px-6 py-3 bg-gray-50 border-b border-gray-200">
							<FormattedMessage id="Details" />
						</div>
						{meta.map(({key, value}) => (
							<PanelRow
								key={key}
								label={<FormattedMessage id={key} />}
								value={value ?? '-'}
							/>
						))}
					</>
				)}
			</div>
		</Panel>
	);
}
